module.exports = __webpack_public_path__ + "img/24.f5d2244d.jpg";